import React from 'react';
import { Card } from 'react-bootstrap';
// import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import './Products.css';

import { sensorDitoData } from "../assets/ProductsData";
import { sensorFogData } from "../assets/ProductsData";
import { sensorFFData } from "../assets/ProductsData";

import sensorDitoImg from "../images/ProductImg/SensorDito.jpg";
import sensorFogImg from "../images/ProductImg/SensorFog.jpg";
import sensorFFImg from "../images/ProductImg/SensorFF.jpg";

function ProductSensor() {
  // console.log("get into ProductSensor()");
  return (
    <div className='products-page'>
      <header className='mt-5'>
        <Container className='h-100 d-flex align-items-center justify-content-center'>
          {/* <div className='container h-100 d-flex align-items-top justify-content-center'> */}
          <h1 className='text-light'>Product / Sensor</h1>
        </Container>
      </header>

      <section id='sensordito' className='block product-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 text-primary'>Sensor / DITO</h2>
        <Container fluid className='d-flex'>
          <Row>
            <Col lg={4} className='d-flex justify-content-center'>
              <img style={{ height: '80vh' }} src={sensorDitoImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={8} className='d-flex justify-content-around'>
              <Row> {sensorDitoData.map(sensor => {
                return (
                  <Col lg={6} key={sensor.id}>
                    <Container className='holder'>
                      <Card className='bg-info-subtle p-0 m-0'>
                        <Card.Title className='text-center fs-3 text-primary'>{sensor.title}</Card.Title>
                        <Card.Text className='fs-6' style={{ whiteSpace: 'pre-wrap' }}>{sensor.text}</Card.Text>
                      </Card>
                    </Container>
                  </Col>
                )
              })} </Row>
            </Col>
          </Row>
        </Container>
      </section >

      <section id='sensorff' className='block product-block bg-info-subtle'>
        <h2 className='title-holder fs-1 text-success'>Sensor / FilmFilm</h2>
        {/* <h2 className='title-holder fs-1 fw-bold text-primary'>Sensor / DITO</h2> */}
        <Container fluid className='d-flex'>
          {/* <div className='subtitle'>DITO Sensor</div> */}
          <Row>
            <Col lg={8} className='d-flex justify-content-around'>
              {/* <Col lg={8} className='d-flex flex-column justify-content-around'> */}
              <Row> {sensorFFData.map(sensor => {
                return (
                  <Col lg={6} key={sensor.id}>
                    <Container className='holder'>
                      <Card className='bg-primary-subtle p-0 m-0'>
                        {/* <Card className='bg-info-subtle border-1 p-0 m-0'> */}
                        {/* <Card.Img variant="top" src={ sensor.image } /> */}
                        {/* <Card.Body> */}
                        {/* <time>{sensor.time}</time> */}
                        <Card.Title className='text-center fs-3 text-success'>{sensor.title}</Card.Title>
                        <Card.Text className='fs-6' style={{ whiteSpace: 'pre' }}>{sensor.text}</Card.Text>
                        {/* <Card.Text>{sensor.price}</Card.Text> */}
                        {/* <a href={sensor.link} className='btn btn-danger'>Read More<i className='fas fa-chevron-right'></i></a> */}
                        {/* </Card.Body> */}
                      </Card>
                    </Container>
                  </Col>
                )
              })} </Row>
            </Col>
            <Col lg={4} className='d-flex justify-content-center'>
              {/* <Col className='col-lg-4 d-flex justify-content-center'> */}
              <img style={{ height: '60vh' }} src={sensorFFImg} className='mt-5 mt-lg-0' alt="" />
              {/* <img style={{ height: '80vh' }} src={sensoDitor} className='img-fluid w-80 mt-4 mt-lg-0' alt="" /> */}
            </Col>
          </Row>
        </Container>
      </section >

      <section id='sensorfog' className='block product-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 text-primary'>Sensor / FOG(FPC,FPCA)</h2>
        <Container fluid className='d-flex'>
          <Row>
            <Col lg={4} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={sensorFogImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={8} className='d-flex justify-content-around'>
              <Row> {sensorFogData.map(sensor => {
                return (
                  <Col lg={6} key={sensor.id}>
                    <Container className='holder'>
                      <Card className='bg-info-subtle p-0 m-0'>
                        <Card.Title className='text-center fs-3 text-primary'>{sensor.title}</Card.Title>
                        <Card.Text className='fs-6' style={{ whiteSpace: 'pre' }}>{sensor.text}</Card.Text>
                      </Card>
                    </Container>
                  </Col>
                )
              })} </Row>
            </Col>
          </Row>
        </Container>
      </section >
    </div >
  )
}

export default ProductSensor;